import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { listDensityControlSx } from './listTableChrome'
import { useDensity } from '@/shared/density/DensityProvider'

export const LIST_ROW_OVERFLOW_COL_WIDTH = 40

export type ListRowOverflowItem = {
  id: string
  label: string
  icon?: React.ReactNode
  color?: 'error' | 'success'
  disabled?: boolean
  onClick: (e: React.MouseEvent<HTMLElement>) => void
}

export function ListRowOverflow(props: {
  items: ListRowOverflowItem[]
  buttonRef?: React.Ref<HTMLButtonElement>
}): React.ReactElement | null {
  const { items, buttonRef } = props
  const { density } = useDensity()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  if (items.length === 0) return null

  const open = Boolean(anchorEl)

  return (
    <>
      <IconButton
        ref={buttonRef}
        size="small"
        aria-label="Row actions"
        aria-haspopup="menu"
        aria-expanded={open ? true : undefined}
        sx={listDensityControlSx(density)}
        onClick={(e) => {
          e.stopPropagation()
          setAnchorEl(e.currentTarget)
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.id}
            disabled={!!item.disabled}
            onClick={(e) => {
              e.stopPropagation()
              if (item.disabled) return
              setAnchorEl(null)
              item.onClick(e)
            }}
            sx={item.color ? { color: `${item.color}.main` } : undefined}
          >
            {item.icon ? (
              <ListItemIcon sx={item.color ? { color: `${item.color}.main` } : undefined}>
                {item.icon}
              </ListItemIcon>
            ) : null}
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
